<div class="promo-card">
  <div class="promo-image-placeholder">
    <img src="../../../../../assets/images/da-discuss.png" alt="">
  </div>
  <h3>Still confused?</h3>
  <p>Speak with an admissions expert who has helped <strong>2,400+ students</strong> get into top universities</p>
  <button class="cta-btn">Contact support &rarr;</button>
</div>
